// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const workoutApi = baseApi.injectEndpoints({
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllWorkouts: builder.query({
      query: () => {
        return {
          url: "workout",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ["Workout"],
    }),
    getWorkoutDetails: builder.query({
      query: (id) => {
        return {
          url: `workout/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Workout"],
    }),
    getWorkoutComments: builder.query({
      query: (id) => {
        return {
          url: `workout/${id}/comment`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ["Workout"],
    }),
    deleteWorkout: builder.mutation({
      query: (id) => {
        return {
          url: `workout/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ["Workout"],
    }),
    deleteWorkoutComment: builder.mutation({
      query: (id) => {
        return {
          url: `workout/comment/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["Workout"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllWorkoutsQuery,
  useGetWorkoutDetailsQuery,
  useGetWorkoutCommentsQuery,
  useDeleteWorkoutMutation,
  useDeleteWorkoutCommentMutation,
} = workoutApi;
